import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'RoundUp'})
export class RoundUp implements PipeTransform {
  transform(value: any): number {
    value = Number(value);
    return Math.ceil(value);
  }
}
